import axios from "axios";

const prodgqlURL = "http://54.193.108.62:8500/graphql";
const devgqlURL = "http://localhost:8080/graphql";
const prodApiBaseURL = "http://54.193.108.62:9000/admin-api";
const devApiBaseURL = "http://localhost:8000";
const googlePlaceAPI =
	"https://maps.googleapis.com/maps/api/place/queryautocomplete/json";
const googlePlaceAPIKey = "AIzaSyCK-VcjLofVgBWeOzuZI1zYHMmq14ByQX4";

const graphQL = process.env.NODE_ENV === "production" ? prodgqlURL : prodgqlURL;
const apiBaseURL =
	process.env.NODE_ENV === "production" ? prodApiBaseURL : prodApiBaseURL;

const config = {
	graphQL,
	apiBaseURL,
	googlePlaceAPI,
	googlePlaceAPIKey,
};

export default config;
axios.defaults.baseURL = config.apiBaseURL;
